import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { includes } from 'lodash';
import { InlineIcon } from '../../../../../inline-icon/inline-icon';
import ScheduledIcon from '../../../../../../icons/compiled/components/ScheduledIcon';
import SparkIcon from '../../../../../../icons/compiled/components/SparkIcon';
import TagIcon from '../../../../../../icons/compiled/components/TagIcon';
import TriangleIcon from '../../../../../../icons/compiled/components/TriangleIcon';
import { VIDEO_CARD_TYPES } from '@wix/wix-vod-constants/video-cards';
import { ItemType } from '@wix/wix-vod-constants/api-types';
import styles from './styles.scss';
export const PLAYABLE_VIDEO_CARD_TYPES = [
    VIDEO_CARD_TYPES.VIDEO,
    VIDEO_CARD_TYPES.RECENT_VIDEO,
    VIDEO_CARD_TYPES.CHANNEL,
];
export const CardThumbnailPlaceholderIcon = ({ type, thumbnailUrl, itemType, }) => {
    if (itemType === ItemType.ItemScheduled) {
        return thumbnailUrl ? null : (React.createElement(InlineIcon, { className: styles['icon-scheduled'], icon: React.createElement(ScheduledIcon, null) }));
    }
    if (includes(PLAYABLE_VIDEO_CARD_TYPES, type)) {
        return (React.createElement(InlineIcon, { className: classNames(styles.triangle, {
                [styles['with-url']]: thumbnailUrl,
            }), icon: React.createElement(TriangleIcon, null) }));
    }
    if (thumbnailUrl) {
        return null;
    }
    switch (type) {
        case VIDEO_CARD_TYPES.PRODUCT:
            return React.createElement(InlineIcon, { className: styles.icon, icon: React.createElement(TagIcon, null) });
        case VIDEO_CARD_TYPES.CUSTOM:
            return React.createElement(InlineIcon, { className: styles.icon, icon: React.createElement(SparkIcon, null) });
        default:
            return null;
    }
};
CardThumbnailPlaceholderIcon.propTypes = {
    type: PropTypes.string,
    thumbnailUrl: PropTypes.string,
    itemType: PropTypes.string,
};
//# sourceMappingURL=thumbnail-placeholder-icon.js.map